import React from 'react';
import { Title } from '../../components/title';
import { createCn } from 'bem-react-classname';
import PriceLink from './link';
import './style.css';
import { usePackages } from '../../utils/usePackages';

const cn = createCn('prices');

export const Prices = React.memo(() => {
    const { groups, loading } = usePackages();

    return (
        <div className={ cn() }>
            <div><Title title={ 'Prices' }/></div>

            <div className={ cn('content') }>
                { loading && <div className={ cn('loading') }>Updating prices…</div> }

                { !loading && groups.map(group => (
                    <div key={ group.category } className={ cn({ pane: true }) }>
                        <div className={ cn({ title: true }) }>{ group.category }</div>

                        <div className={ cn({ content: true }) }>
                            { group.items.map(item => (
                                <div key={ item.id } className={ cn({ row: true }) }>
                                    <PriceLink
                                        text={ item.text_for_link }   // готовый текст
                                        sub_title={ item.sub_title }   // готовый текст
                                        price={ item.price_text }     // отформатированная цена
                                        linkId={ item.id }            // id === linkId
                                    />
                                </div>
                            )) }
                        </div>
                    </div>
                )) }
            </div>
        </div>
    );
});
